$(function () {
    function roundUpToTwoDecimals(value) {
        var number = Number(value);
        if (Number.isNaN(number)) {
            return 0;
        }

        return Math.ceil(number * 100) / 100;
    }

    function pushConfiguratorCompleteEvent(optionsJson, totalPrice) {
        if (optionsJson && totalPrice !== undefined && totalPrice !== null && totalPrice !== '') {
            var options = JSON.parse(optionsJson);
            if (options.length > 0) {
                var vehicle = options[0];
                var items = options.map(function (option) {
                    var itemPrice = option.Price.Price <= option.Price.PromoPrice ? option.Price.Price : option.Price.PromoPrice;

                    return {
                        'item_id': option.Sku.trim(),
                        'item_name': option.Value.trim(),
                        'item_brand': 'BOSS',
                        'item_category': option.Title === 'Vehicle' ? 'sidewalk' : 'attachment',
                        'price': roundUpToTwoDecimals(itemPrice),
                        'quantity': 1
                    };
                });
                dataLayer.push({ event: 'gtm.clear' });
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    'event': 'configurator_complete',
                    'configurator_type': 'snowrator_builder',
                    'vehicle_model': vehicle.Sku.trim(),
                    'ecommerce': {
                        'currency': 'USD',
                        'value': roundUpToTwoDecimals(totalPrice),
                        'items': items
                    }
                });
            }
        }
    }

    $(document).on('submit', '#submit-form', function () {
        var options = $('#SelectedOptions').val();
        var totalPrice = Number($('#TotalPrice').val());
        pushConfiguratorCompleteEvent(options, totalPrice);
    });
});